<template lang="pug">
.h-screen.w-screen.m-auto.flex.justify-center
    .flex.self-center.flex-col(
        class="w-[calc(100vw-30px)] max-w-[340px] md:max-w-[360px]"
    )
        .flex.flex-1.justify-center.flex-col
            .text-lg.font-bold 404
            .w-full.text-sm Halaman ini tidak ditemukan.
            <pre class="text-sm text-red-500 mt-5">{{ error }}</pre>
    .fixed.bottom-3.right-3
        Color
</template>
<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
    error: Object as () => NuxtError,
})

useHead({
    title: 'Err | Dashboard',
})

const toast = useToast()
// const router = useRouter();
</script>
